import { Paper as MantinePaper } from "@mantine/core"

export const Paper = MantinePaper.extend({
  defaultProps: {
    radius: "lg",
  },
})
